import React from 'react';

interface AdminChatSvgProps {
    style?: React.CSSProperties;
}

const AdminChatSvg: React.FC<AdminChatSvgProps> = ({ style }) => {
    return (
        <svg
            className="unf-icon"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="#8D96AA"
            style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.71 9.29a2.28 2.28 0 0 0-2.33-2 1.13 1.13 0 0 0-.55.15 7.73 7.73 0 0 0-13.7 0 1.16 1.16 0 0 0-.55-.15 2.27 2.27 0 0 0-2.35 2.13v2.15a2.26 2.26 0 0 0 2.35 2.17h.15a7.75 7.75 0 0 0 14.5 0h.15c.318 0 .633-.057.93-.17A8.75 8.75 0 0 1 17 18.42a7.842 7.842 0 0 1-1.82 1.09.762.762 0 1 0 .32 1.49.66.66 0 0 0 .3-.07A8.62 8.62 0 0 0 18 19.6c2.89-2.17 4.3-5.31 4.3-9.61a.74.74 0 0 0-.59-.7ZM4.23 12.18a.7.7 0 0 1-.5-.61V9.42a.71.71 0 0 1 .5-.61v3.37ZM12 17.24a6.25 6.25 0 1 1-.04-12.5 6.25 6.25 0 0 1 .04 12.5Zm8.25-5.67a.7.7 0 0 1-.5.61V8.81a.71.71 0 0 1 .5.61v2.15ZM15 11.24a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0 .75.75 0 1 0-1.5 0 3.75 3.75 0 1 0 7.5 0 .76.76 0 0 0-.75-.75Zm-4.53 8.72a.75.75 0 0 1 .53-.22h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.53-1.28Z"
            />
        </svg>
    );
};

export default AdminChatSvg;
